/*!
 * @jscrypto/formats v0.12.0
 * Copyright 2026 Chen, Yi-Cyuan
 * Released under the MIT license
 */
import { concatBytes, equalBytes } from '@jscrypto/core';

const OPENSSL_SALTED_MAGIC = new Uint8Array([
    0x53, 0x61, 0x6c, 0x74, 0x65, 0x64, 0x5f, 0x5f,
]);
const opensslFormat = {
    kind: 'format',
    name: 'OpenSSL',
    mediaType: 'application/octet-stream',
    stringify({ ciphertext, salt }) {
        if (!salt) {
            return ciphertext.slice();
        }
        assertSalt(salt);
        return concatBytes(OPENSSL_SALTED_MAGIC, salt, ciphertext);
    },
    parse(input) {
        if (!hasSaltHeader(input)) {
            return { ciphertext: input.slice() };
        }
        return {
            salt: input.slice(OPENSSL_SALTED_MAGIC.length, OPENSSL_SALTED_MAGIC.length + 8),
            ciphertext: input.slice(OPENSSL_SALTED_MAGIC.length + 8),
        };
    },
};
const opensslPreset = {
    kind: 'preset',
    name: 'openssl',
    components() {
        return [opensslFormat];
    },
};
function hasSaltHeader(input) {
    return input.length >= 16 && equalBytes(input.subarray(0, OPENSSL_SALTED_MAGIC.length), OPENSSL_SALTED_MAGIC);
}
function assertSalt(salt) {
    if (salt.length !== 8) {
        throw new Error('OpenSSL salt must be 64 bits.');
    }
}

function formatsPreset() {
    return {
        kind: 'preset',
        name: 'formats',
        components() {
            return [opensslPreset];
        },
    };
}

export { OPENSSL_SALTED_MAGIC, formatsPreset, opensslFormat, opensslPreset };
//# sourceMappingURL=index.mjs.map
